export default __webpack_public_path__ + "static/wsb_horizontal_logo-30db11d855a233c2bafcd70ceca48374.png";